export const screens = {
    NONE: 'none',
    HERO: 'hero',
    SITEMAP: 'sitemap',
    PARTNERS: 'partners',
    INVESTORS: 'investors',


    PRODUCT: 'product',
    PRODUCT__INNER_1: 'product-0',
    PRODUCT__INNER_2: 'product-1',

    ROADMAP: 'roadmap',
    ROADMAP__INNER_1: 'roadmap-0',
    ROADMAP__INNER_2: 'roadmap-1',
    ROADMAP__INNER_3: 'roadmap-2',

    SOCIAL: 'social',
}